import React from 'react';
import { PropTypes } from 'prop-types';

const Banner = ({ mainText, subText, className }) => (
  <div className={ `toast ${ className } text-center mb` }><h2 className="bold mb-0">{ mainText }</h2>
    { subText && <div className="mb-0">{subText}</div> }
  </div>
);

Banner.propTypes = {
  mainText: PropTypes.string,
  subText: PropTypes.string,
  className: PropTypes.string
};

Banner.defaultProps = {
  mainText: null,
  subText: null,
  className: ''
};

export default Banner;
